const PLANNED_FIELDS = ["perceel", "gewicht", "soort", "koelcel", "rij"];

// Manual phone entry keeps the chosen party independent of the planning queue.
// Normal entry keeps the existing preset and reset behavior.
export function updateInscanPartyInfo({
  partyInfo,
  field,
  value,
  followPlanning = true,
  planningPreset = null,
}) {
  const next = {
    ...partyInfo,
    [field]: field === "rij" && value ? Number(value) : value,
  };
  if (field === "koelcel") return { ...next, rij: "", notitie: "" };
  if (field !== "snijgroep" || !followPlanning) return next;

  return {
    ...next,
    ...Object.fromEntries(PLANNED_FIELDS.map((key) => [
      key,
      planningPreset ? planningPreset[key] || next[key] : "",
    ])),
    notitie: planningPreset?.notitie || "",
  };
}
